import { useEffect, useState, useRef } from 'react'
import { Drawer, Button, message, Form, Input, Select, Radio } from 'mk-pc'
import { IconSelector } from 'mk-pc'
import { NavSelector, AppSelector } from '@/components'
import { getNav, addNav, updateNav } from '../../service'
import './index.scss'

interface Props {
  current?: any
  visible: boolean
  onClose?: () => void
}

/**
 * 导航权限点
 */
export const NavAction = ({ visible, current, onClose }: Props) => {
  const [messageApi, contextHolder] = message.useMessage()
  const [form] = Form.useForm()
  const [loading, setLoading] = useState(false)
  const [isEdit, setIsEdit] = useState(false)
  const defaultFormData = useRef({
    id: '',
    parentId: '',
    code: '',
    name: '',
    type: 0,
    icon: '',
    path: '',
    order: 0,
    memo: '',
    status: 1
  })

  useEffect(() => {
    if (!visible) return

    if (current && current.id) {
      setIsEdit(true)
      fetchDetail()
    } else {
      setIsEdit(false)
      defaultFormData.current = {
        id: '',
        parentId: '',
        code: '',
        name: '',
        type: 0,
        icon: '',
        path: '',
        order: 0,
        memo: '',
        status: 1
      }
      form.setFieldsValue(defaultFormData.current)
    }
  }, [visible])

  /**
   * 加载详情
   */
  const fetchDetail = async () => {
    defaultFormData.current = await getNav(current.id)

    form.setFieldsValue(defaultFormData.current)
  }

  /**
   * 提交信息
   */
  const handleSubmit = async () => {
    try {
      const values = await form.validateFields()
      setLoading(true)

      if (defaultFormData && defaultFormData.current.id) {
        await updateNav({
          id: defaultFormData.current.id,
          ...values
        })
      } else {
        await addNav(values)
      }

      messageApi.open({
        type: 'success',
        duration: 1,
        content: defaultFormData.current.id ? '更新成功' : '创建成功',
        onClose: () => {
          setLoading(false)
          if (onClose) {
            onClose()
          }
        }
      })
    } catch (error) {
      setLoading(false)
    }
  }

  return (
    <>
      {contextHolder}
      <Drawer
        title="导航维护11"
        width={640}
        size="small"
        className="edit-nav"
        open={visible}
        onClose={onClose}
        closeIcon={false}
      >
        <div className="edit-nav__form">
          <Form
            name="basic"
            form={form}
            initialValues={defaultFormData.current}
            labelCol={{ span: 4, offset: 0 }}
            autoComplete="off"
          >
            <Form.Item label="所属应用" name="appId" rules={[{ required: true, message: '请选择所属应用' }]}>
              <AppSelector />
            </Form.Item>
            <Form.Item label="上级导航" name="parentId">
              <NavSelector />
            </Form.Item>
            <Form.Item label="导航编码" name="code" rules={[{ required: true, message: '请输入导航编码' }]}>
              <Input style={{ height: 34 }} readOnly={isEdit} placeholder="导航编码" />
            </Form.Item>
            <Form.Item label="导航名称" name="name" rules={[{ required: true, message: '请输入导航名称' }]}>
              <Input style={{ height: 34 }} placeholder="导航名称" />
            </Form.Item>
            <Form.Item label="导航类型" name="type">
              <Radio.Group
                options={[
                  { label: '普通导航', value: 0 },
                  { label: '模块导航', value: 1 }
                ]}
              />
            </Form.Item>
            <Form.Item label="图标选择" name="icon" rules={[{ required: true, message: '请选择图标' }]}>
              <IconSelector />
            </Form.Item>
            <Form.Item label="访问路径" name="path">
              <Input style={{ height: 34 }} placeholder="访问路径" />
            </Form.Item>
            <Form.Item label="导航排序" name="order">
              <Input style={{ height: 34 }} placeholder="导航排序" />
            </Form.Item>
            <Form.Item label="导航状态" name="status">
              <Select
                options={[
                  { value: 1, label: '启用' },
                  { value: 0, label: '停用' }
                ]}
              />
            </Form.Item>
            <Form.Item label="导航备注" name="memo">
              <Input.TextArea placeholder="备注信息" autoSize={{ minRows: 2, maxRows: 6 }} />
            </Form.Item>
          </Form>
        </div>
        <footer className="edit-nav__footer">
          <Button loading={loading} className="save-button" onClick={handleSubmit}>
            确定
          </Button>
          <Button onClick={() => onClose && onClose()}>返回</Button>
        </footer>
      </Drawer>
    </>
  )
}
